/* @flow */

import * as uiActions from './ui-actions';
import {uiReducer} from './ui-reducer';
import * as uiSelectors from './ui-selectors';

export const SalesAutomationUi = {
    uiReducer,
    ...uiSelectors,
    ...uiActions,
};

export type {SalesAutomationUiState} from './ui-reducer';
